import "./PageHeader.scss";

import { Flex } from "@fluentui/react-northstar";
import React from "react";

import { PollyIcon } from "../_shared/components/PollyIcon";
import {
  getAltLogoFromPageContext,
  getAppTitleFromPageContext,
} from "../_shared/utils/applicationHelpers";

interface HelpLink {
  url: string;
  label: string;
}
interface Props {
  helpLink?: HelpLink;
}
export const PageHeader: React.FC<Props> = ({ helpLink }) => {
  return (
    <div className="page-header">
      <Flex vAlign="center">
        <Flex.Item grow>
          <Flex vAlign="center">
            <img
              src={getAltLogoFromPageContext()}
              alt={`${getAppTitleFromPageContext()} logo`}
            ></img>
          </Flex>
        </Flex.Item>
        <Flex.Item>
          {helpLink && (
            <a
              className="page-header__help-link"
              href={helpLink.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <PollyIcon icon="q-info-icon" inheritColor label={helpLink.label} />
            </a>
          )}
        </Flex.Item>
      </Flex>
    </div>
  );
};
